import { Navigate, Outlet } from 'react-router-dom'
import globalStore from 'store'
import { VerifyYourEmail } from 'pages/user/MessagePages'
import { useFlags } from 'launchdarkly-react-client-sdk'

const ProtectedByEmailVerification = () => {
  const flags = useFlags()
  const register = globalStore(state => state.register)

  if (!register) return <Navigate to="" />

  if (!flags.primaryEmailVerification) return <Outlet />

  if (register.emailValidated) return <Outlet />

  return <VerifyYourEmail email={register.email} />
}

export default ProtectedByEmailVerification
